export default {
  // 页面标题
  title: 'Your Campaign Is Live—Congrats!',
  
  // 页面描述
  description: {
    prefix: 'Within the',
    highlight: 'next 24 hours',
    suffix: ', AhaCreator will match you with influencers, and once the matching is complete, you will receive a confirmation reminder to ensure the collaboration goes smoothly.',
  },
  
  // 按钮
  buttons: {
    checkInstructions: 'Check AhaCreator Instructions',
    viewCampaign: 'View campaign',
  },
  
  // 下一步说明标题
  nextStepsTitle: 'Here\'s What Happens Next:',
  
  // 步骤说明
  steps: {
    step1: {
      title: 'AhaCreator sends invites to influencers',
      description: 'We automatically invite the right influencers for your brand. Within 72 hours, you\'ll start receiving applications and get notified as soon as someone accepts. You can then review each profile and choose to approve or decline.',
    },
    step2: {
      title: 'Influencers produce content',
      description: 'Once content is submitted, you\'ll be notified immediately. Review and approve it, or provide feedback to ensure brand alignment.',
    },
    step3: {
      title: 'You get results',
      description: 'After content goes live, access your performance report with key metrics like views, clicks, and engagement, viewable by campaign or individual influencer.',
    },
    stepApproval: {
      title: 'You approve content',
      description: 'Once the influencer submits content, you\'ll get instant notifications. Review and either approve or provide feedback to ensure it matches your brand.',
    },
  },
};
